export const HOME = '/';
export const TRACKPACKAGE = 'track-package';
export const INVOICE = 'invoice';
export const PAYMENT = 'payment-success';
